{
  "palette": {
    "primary": {
      "main": "#274653"
    },
    "secondary": {
      "main": "#A45E35"
    },
    "text": {
      "primary": "#274653"
    },
    "background": {
      "default": "#F1F6F8"
    }
  },
  "components": {
    "MuiButton": {
      "styleOverrides": {
        "outlined": {
          "background": "white",
          "borderRadius": "34px"
        },
        "contained": {
          "borderRadius": "34px",
          "&$disabled": {
            "backgroundColor": "#dde9ef"
          }
        },
        "text": {
          "padding": "0"
        }
      }
    },
    "MuiCard": {
      "styleOverrides": {
        "root": {
          "padding": "16px",
          "fontSize": "14px"
        }
      }
    },
    "MuiBottomNavigation": {
      "styleOverrides": {
        "root": {
          "backgroundColor": "white"
        }
      }
    },
    "MuiBottomNavigationAction": {
      "styleOverrides": {
        "root": {
          "color": "white",
          "&$selected": {
            "color": "white"
          }
        }
      }
    },
    "MuiTextField": {
      "styleOverrides": {
        "root": {
          "backgroundColor": "white"
        }
      }
    },
    "MuiSelect": {
      "styleOverrides": {
        "root": {
          "backgroundColor": "white"
        }
      }
    },
    "MuiTab": {
      "styleOverrides": {
        "root": {
          "textTransform": "none"
        }
      }
    }
  }
}
